import React from 'react';

const COMMON_CLAUSES = [
    {
        id: 'arbitration',
        title: 'Arbitration Clause',
        text: 'Any dispute arising out of or in connection with this Agreement shall be settled by arbitration in accordance with the Arbitration and Conciliation Act, 1996. The arbitration shall be held at {{jurisdiction}} and the language of proceedings shall be English.',
    },
    {
        id: 'force_majeure',
        title: 'Force Majeure',
        text: 'Neither party shall be liable for any failure or delay in performing their obligations where such failure or delay results from any cause that is beyond the reasonable control of that party, including but not limited to acts of God, natural disasters, war, terrorism, riots, embargoes, acts of civil or military authorities, fire, floods, or pandemic.',
    },
    {
        id: 'termination',
        title: 'Termination',
        text: 'Either party may terminate this Agreement by providing {{notice_period}} days written notice to the other party. Upon termination, all rights and obligations of the parties shall cease, except for any obligations that by their nature should survive termination.',
    },
    {
        id: 'payment_schedule',
        title: 'Payment Schedule',
        text: 'Payments shall be made according to the following schedule:\n1. {{first_payment_percentage}}% on signing: {{first_payment_amount}}\n2. {{second_payment_percentage}}% on {{second_milestone}}: {{second_payment_amount}}\n3. Balance on completion: {{balance_amount}}',
    },
    {
        id: 'confidentiality',
        title: 'Confidentiality',
        text: 'The parties agree to keep confidential all information exchanged during the course of this Agreement and shall not disclose such information to any third party without the prior written consent of the other party.',
    },
    {
        id: 'indemnity',
        title: 'Indemnity',
        text: 'Each party shall indemnify and hold harmless the other party against any claims, damages, losses, and expenses arising from any breach of this Agreement or from any negligent or wrongful act or omission.',
    },
    {
        id: 'notices',
        title: 'Notices',
        text: 'All notices and communications under this Agreement shall be in writing and shall be delivered personally, sent by registered post, or by email to the addresses specified herein. Notices shall be deemed delivered upon receipt.',
    },
];

const ClauseLibrary = ({ onAddClause }) => {
    return (
        <div>
            <h4>Clause Library</h4>
            <div className="clause-library-list">
                {COMMON_CLAUSES.map((clause) => (
                    <div key={clause.id} className="clause-library-item">
                        <h5>{clause.title}</h5>
                        <p>{clause.text.substring(0, 80)}...</p>
                        <button className="clause-add-btn" onClick={() => onAddClause(clause)}>
                            + Add to Template
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ClauseLibrary;
